module.exports = __webpack_public_path__ + "img/msc_seminar_2024_heddar.b9ac9e9a.jpg";